const spinnerStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative', // 'absolute'
  marginTop: '50px',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: '1000',
};

const spinnerElementStyles = {
  width: '40px',
  height: '40px',
  border: '4px solid #f3f3f3',
  borderTop: '4px solid #3498db',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};

(function injectKeyframes() {
    const styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = `
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `;
    document.head.appendChild(styleElement);
  })();

export function showLoadingSpinner(container: HTMLElement) {
  const existingSpinner = container.querySelector('.loading-spinner');
  if (existingSpinner) return;

  const spinnerWrapper = document.createElement('div');
  spinnerWrapper.className = 'loading-spinner';

  Object.assign(spinnerWrapper.style, spinnerStyles);

  const spinnerElement = document.createElement('div');
  Object.assign(spinnerElement.style, spinnerElementStyles);

  spinnerWrapper.appendChild(spinnerElement);
  container.appendChild(spinnerWrapper);
}

export function hideLoadingSpinner(container: HTMLElement) {
  const spinner = container.querySelector('.loading-spinner');
  if (spinner) {
    spinner.remove();
  }
}